var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var KeepoIcon = function (_a) {
    var color = _a.color;
    return (_jsx("svg", __assign({ width: "9", height: "12", viewBox: "0 0 9 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.85092 2.4545C7.87822 3.42653 7.27608 4.76911 7.27608 6.24998C7.27608 7.73085 7.87822 9.07343 8.85092 10.0455L6.95318 11.9432C5.49447 10.4845 4.59091 8.47061 4.59091 6.24998C4.59091 4.02935 5.49447 2.01548 6.95318 0.556763L8.85092 2.4545ZM0.56311 0.879664H3.24827V11.6203H0.56311V0.879664Z", fill: color }, void 0) }), void 0));
};
